<template>
  <div class="py-3 px-5">
     <ThirdPartyCodeResult v-if="reportStatus" @reopen-camera="reopenCamera" :decodedData="decodedData" />
     <ErrorResults v-else :code-status="status" :isHybrid="isHybrid" :imageQuality="imageQuality" :photo="photo" />
  </div>
</template>

<script setup>
import ThirdPartyCodeResult from '@/components/codeResponses/ThirdPartyCodeResult.vue'
import { events } from '@/utils/events'
import { computed } from 'vue'
import ErrorResults from './codeResponses/ErrorResults.vue'

const props = defineProps({
  status: {
    type: String,
    required: true
  },
  imageQuality: Array, 
  photo: String,
  isHybrid: Boolean,
  decodedData: Object
})

const reportStatus = computed(() => props.status === 'third_party' || props.status === 'not_found')

const reopenCamera = () => {
  events.value.triggerTakePicture = true
}
</script>
